<template>
  <div class="cmp-footer">
    <div class="footer" v-show="isShow">
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
      showBeijing: true
    }
  },
  methods: {
    handleShowAddr(val) {
      this.showBeijing = val
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  // height: 216px;
  // overflow: hidden;
  background-color: #2f3026;
  .footer-content {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        width: 300px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .tab-addr {
          margin-bottom: 10px;
          span {
            display: inline-block;
            width: 80px;
            text-align: center;
            color: #7d7a7a;
            box-sizing: border-box;
            &.active {
              color: #fff;
              border-bottom: solid 1px $border;
            }
          }
        }
        p {
          font-size: 20px;
          color: #fff;
          padding: 10px 0;
        }
        span {
          color: #7d7a7a;
          font-weight: 300;
          padding: 5px 0;
          cursor: pointer;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    text-align: center;
    border-top: solid 1px $border;
    line-height: 60px;
    span {
      color: #fff;
    }
  }
}
</style>


